import React, { useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import utilsService, { TOAST_TYPE } from '../../helpers/utils'


import TextInput from '../../shared/Fields/TextInput';

import st26service from '../../services/st26service';
import Switch from '@mui/material/Switch';
import * as FileSaver from 'file-saver';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        margin: '0 auto 28px',
        minHeight: '260px',
        padding: '23px 16px 14px',
    },
    headerPipe: {
        margin: '0 10px'
    },
    searchInput: {
        width: '30%'
    },
    buttonStyleCancel: {
        float: 'right',
        textTransform: 'none',
        margin: '4px',
        color: 'white',
        backgroundColor: '#008EC5 !important',
        border: '1px solid #1F4E79 !important',
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        }
    },
    antibodyNumInput: {
        width: '8%'
    },
    accountInfo: {
        float: 'right',
        margin: '4px 0 0 4px !important',
        textTransform: 'none !important',
        /* margin-top: 4px !important; */
        backgroundColor: '#db862c !important',
        border: '1px solid #ca751b !important',
        color: 'white !important',
    }
}));

function ThreeLetterCodeConversion() {
    const { t } = useTranslation('common');
    const classes = useStyles();
    const history = useHistory();
    const [authInfo, setAuthInfo] = useState();
    const [formdata, setFormData] = useState({});
    const { workflowId } = useParams();
    const toastRef = useRef(null);
    const [getResponse, setGetResponse] = useState(null);
    const [toggle1, setToggle] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [conversionCompletedforThree, setConversionCompletedforThree] = useState(false);
    const [conversionCompletedforSingle, setConversionCompletedforSingle] = useState(false);
    const toggle = useSelector(state => state.setToggle.toggle)
    const userInfo = useSelector(state => state.setUserInfo);
    function showfil() {
        if (window.File && window.FileReader && window.FileList && window.Blob) {
             var preview = document.getElementById('letterCodeConversion');
             var file = document.querySelector('input[type=file]').files[0];
             if (file) {
                // If a file is uploaded, set the uploaded file name
                setUploadedFileName(file.name);
            } else {
                setUploadedFileName('');
            }
             var reader = new FileReader();
       
             var textFile = /text.*/;
             if (file.type.match(textFile)) {
                reader.onload = function (event) {
             // preview.innerHTML = event.target.result;
                preview.value = event.target.result;
                formik.setFieldValue("st26input", event.target.result);
               };
             } else {
               preview.innerHTML =
                 "<span class='error'>It doesn't seem to be a text file!</span>";
             }
             reader.readAsText(file);
          } else {
             alert('Your browser is too old to support HTML5 File API');
           }
    }  

    function downloadTextFile() {
        if (getResponse != null) {
            const blob = new Blob([getResponse], {
                type: "text/plain;charset=utf-8;"
            });
            FileSaver.saveAs(blob, uploadedFileName + ".txt");
            formik.resetForm();
            setGetResponse(null);
            setConversionCompletedforThree(false);
            setConversionCompletedforSingle(false);
            resetFileName();
        }
    }

    const resetFileName = () => {
        var fileInput = document.querySelector('input[type=file]');
        fileInput.value = ''; // Clear the file input
        setUploadedFileName(''); // Reset the uploaded file name
    };

    const handleChanged = () => {
        // Reset the form values
        formik.resetForm();
        // Reset the response state
        setGetResponse(null);
        // Clear the text box value
        formik.setFieldValue("st26input", "");
        setConversionCompletedforThree(false);
        setConversionCompletedforSingle(false);
        resetFileName(); // Call resetFileName when toggling
        setToggle(prevToggle => !prevToggle);
    };

    const handleConvertToSingle = async () => {
        formik.setFieldValue("st26input", "");
        const postData = {
            st26input: formik.values.st26input
        };
        try {
            const response = await st26service.convertingThreeToOne(postData, history, t);
            if(response === 'empty'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The .txt file has no sequence data to be parsed.", toastRef);
                resetFileName();
                setConversionCompletedforThree(false);
            }else if(response === 'parsererror'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The data is not correctly structured.\nPlease correct the .txt and try again.", toastRef);
                resetFileName();
                setConversionCompletedforThree(false);
            }else if(response === 'missing'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The data is not correctly structured.\nEither the moltype or Sequence data is missing.", toastRef);
                resetFileName();
                setConversionCompletedforThree(false);
            }
            else{
                setGetResponse(response);
                setConversionCompletedforThree(true);
                formik.setFieldValue("st26input", response); // Update the input field value
            }
            
        } catch (error) {
            console.error("Error during conversion:", error);
            // Handle the error if necessary
        }
    }

    const handleConvertToFasta = () => {
        try {
            // Use the already converted data (getResponse) to convert to FASTA
            if (getResponse) {
                const fastaFormatted = convertToCleanFasta(getResponse);
                setGetResponse(fastaFormatted);
                formik.setFieldValue("st26input", fastaFormatted);
            } else {
                utilsService.showToast(TOAST_TYPE.ERROR, "No converted data available to convert to FASTA.", toastRef);
            }
        } catch (error) {
            console.error("Error during FASTA conversion:", error);
            utilsService.showToast(TOAST_TYPE.ERROR, "Error converting to FASTA format.", toastRef);
        }
    }

    // Helper function to convert ST25 to clean FASTA format
    const convertToCleanFasta = (st25Data) => {
        console.log('Converting to FASTA, input data:', st25Data);
        
        const lines = st25Data.split('\n');
        let fastaOutput = '';
        let currentSequence = '';
        let sequenceCounter = 1;

        
        let inSequenceData = false;
        
        for (let line of lines) {
            line = line.trim();
            
            // Check for <400> tag - this marks the start of a sequence
            if (line.startsWith('<400>')) {
                // Save previous sequence if exists
                if (currentSequence.trim()) {
                    const seqId = `SEQ_${String(sequenceCounter).padStart(4, '0')}`;
                    fastaOutput += `>${seqId}\n${currentSequence.trim()}\n`;
                    console.log(`Added sequence: ${seqId}`);
                    sequenceCounter++;
                }
                
                // Reset for next sequence
                currentSequence = '';
                inSequenceData = true;
                console.log(`Found sequence marker: ${line}`);
                continue;
            } 
            
            // Skip all other ST25 tags (anything starting with <)
            if (line.startsWith('<')) {
                inSequenceData = false;
                continue;
            }
            
            // Skip empty lines
            if (!line) {
                continue;
            }
            
            // Skip lines that are just numbers (line numbers)
            if (line.match(/^\d+$/)) {
                continue;
            }
            
            // If we're in sequence data section (after <400> tag)
            if (inSequenceData) {
                // Accept any line that contains letters as potential sequence data
                // Remove any trailing numbers (line numbers)
                let sequenceLine = line.replace(/\s+\d+\s*$/, '').trim();
                
                // Only add lines that contain alphabetic characters
                if (sequenceLine && sequenceLine.match(/[A-Za-z]/)) {
                    currentSequence += sequenceLine + ' ';
                    console.log(`Added sequence line: ${sequenceLine}`);
                }
            }
        }
        
        // Add the last sequence
        if (currentSequence) {
            const seqId = `SEQ_${String(sequenceCounter).padStart(4, '0')}`;
            fastaOutput += `>${seqId}\n${currentSequence}\n`;
            console.log(`Added final sequence: ${seqId}`);
        }
        
        // If no sequences found with <400> tags, try to extract sequences differently
        if (!fastaOutput.trim()) {
            console.log('No <400> tags found, trying alternative parsing...');
            let sequenceLines = [];
            for (let line of lines) {
                line = line.trim();
                if (line && !line.startsWith('<') && !line.match(/^\s*\d+\s*$/) && line.match(/[A-Za-z]/)) {
                    const cleanLine = line.replace(/\s+/g, '').replace(/\d+/g, '');
                    if (cleanLine.length > 0) {
                        sequenceLines.push(cleanLine);
                    }
                }
            }
            
            if (sequenceLines.length > 0) {
                const allSequence = sequenceLines.join('');
                fastaOutput = `>SEQ_0001\n${allSequence}\n`;
                console.log('Created single sequence from all lines');
            }
        }
        
        console.log('Final FASTA output:', fastaOutput);
        return fastaOutput.trim();
    };

    const handleSequenceVariationSearch = () => {
        if (getResponse) {
            // First convert to FASTA format
            const fastaData = convertToCleanFasta(getResponse);
            
            if (!fastaData || !fastaData.includes('>')) {
                utilsService.showToast(TOAST_TYPE.ERROR, "Unable to convert data to FASTA format for Sequence Variation Search.", toastRef);
                return;
            }
            
            // Parse FASTA sequences
            const lines = fastaData.split('\n');
            const sequences = [];
            let currentHeader = '';
            let currentSeq = '';
            
            for (let line of lines) {
                line = line.trim();
                if (line.startsWith('>')) {
                    if (currentHeader && currentSeq) {
                        sequences.push({ header: currentHeader, sequence: currentSeq });
                    }
                    currentHeader = line;
                    currentSeq = '';
                } else if (line) {
                    currentSeq += line;
                }
            }
            if (currentHeader && currentSeq) {
                sequences.push({ header: currentHeader, sequence: currentSeq });
            }
            
            if (sequences.length === 0) {
                utilsService.showToast(TOAST_TYPE.ERROR, "No valid sequences found for Sequence Variation Search.", toastRef);
                return;
            }
            
            // Classify sequences - ADD THIS MISSING PART
            const classifiedSequences = sequences.map((seq, index) => {
                const cleanSeq = seq.sequence.replace(/\s/g, '').toUpperCase();
                const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
                const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
                const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
                const nucleotideRatio = nucleotideBases / cleanSeq.length;
                
                let isProtein = false;
                if (proteinOnlyAA) {
                    isProtein = true;
                } else if (onlyNucleotides && cleanSeq.length > 10) {
                    isProtein = false;
                } else if (nucleotideRatio > 0.9) {
                    isProtein = false;
                } else {
                    isProtein = true;
                }
                
                return {
                    header: seq.header,
                    sequence: seq.sequence,
                    isProtein: isProtein
                };
            });
            
            const proteinCount = classifiedSequences.filter(seq => seq.isProtein).length;
            const nucleotideCount = classifiedSequences.filter(seq => !seq.isProtein).length;
            const defaultType = proteinCount >= nucleotideCount ? "protein" : "nucleotide";
            
            const proteinSeqs = classifiedSequences
                .filter(seq => seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
                
            const nucleotideSeqs = classifiedSequences
                .filter(seq => !seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            const combinedSeqs = classifiedSequences
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            history.push({
                pathname: '/ipseqvariation',
                state: {
                    seq: combinedSeqs,
                    type: defaultType,
                    proteinSeqs: proteinSeqs,
                    nucleotideSeqs: nucleotideSeqs,
                    proteinCount: proteinCount,
                    nucleotideCount: nucleotideCount
                }
            });
        } else {
            utilsService.showToast(TOAST_TYPE.ERROR, "No converted data available for Sequence Variation Search.", toastRef);
        }
    };

    const handleIpSequenceSearch = () => {
        if (getResponse) {
            // First convert to FASTA format
            console.log('Original getResponse:', getResponse);
            const fastaData = convertToCleanFasta(getResponse);
            console.log('Converted FASTA data:', fastaData);

            if (!fastaData || !fastaData.includes('>')) {
                utilsService.showToast(TOAST_TYPE.ERROR, "Unable to convert data to FASTA format for IP Search.", toastRef);
                return;
            }
            
            // Parse FASTA sequences
            const lines = fastaData.split('\n');
            const sequences = [];
            let currentHeader = '';
            let currentSeq = '';
            
            for (let line of lines) {
                line = line.trim();
                if (line.startsWith('>')) {
                    if (currentHeader && currentSeq) {
                        sequences.push({ header: currentHeader, sequence: currentSeq });
                    }
                    currentHeader = line;
                    currentSeq = '';
                } else if (line) {
                    currentSeq += line;
                }
            }
            if (currentHeader && currentSeq) {
                sequences.push({ header: currentHeader, sequence: currentSeq });
            }
            
            if (sequences.length === 0) {
                utilsService.showToast(TOAST_TYPE.ERROR, "No valid sequences found for IP Search.", toastRef);
                return;
            }
            
            // Classify sequences
            const classifiedSequences = sequences.map((seq, index) => {
                const cleanSeq = seq.sequence.replace(/\s/g, '').toUpperCase();
                const proteinOnlyAA = /[EFHIJKLMPQRSVWYZ]/i.test(cleanSeq);
                const onlyNucleotides = /^[ATGCUN]+$/i.test(cleanSeq);
                const nucleotideBases = (cleanSeq.match(/[ATGCU]/gi) || []).length;
                const nucleotideRatio = nucleotideBases / cleanSeq.length;
                
                let isProtein = false;
                if (proteinOnlyAA) {
                    isProtein = true;
                } else if (onlyNucleotides && cleanSeq.length > 10) {
                    isProtein = false;
                } else if (nucleotideRatio > 0.9) {
                    isProtein = false;
                } else {
                    isProtein = true;
                }
                
                return {
                    header: seq.header,
                    sequence: seq.sequence,
                    isProtein: isProtein
                };
            });
            
            const proteinCount = classifiedSequences.filter(seq => seq.isProtein).length;
            const nucleotideCount = classifiedSequences.filter(seq => !seq.isProtein).length;
            const defaultType = proteinCount >= nucleotideCount ? "protein" : "nucleotide";
            
            const proteinSeqs = classifiedSequences
                .filter(seq => seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
                
            const nucleotideSeqs = classifiedSequences
                .filter(seq => !seq.isProtein)
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            const combinedSeqs = classifiedSequences
                .map(seq => `${seq.header}\n${seq.sequence}`)
                .join('\n');
            
            history.push({
                pathname: '/ipseqsearch',
                state: {
                    seq: combinedSeqs,
                    type: defaultType,
                    proteinSeqs: proteinSeqs,
                    nucleotideSeqs: nucleotideSeqs,
                    proteinCount: proteinCount,
                    nucleotideCount: nucleotideCount
                }
            });
        } else {
            utilsService.showToast(TOAST_TYPE.ERROR, "No converted data available for IP Search.", toastRef);
        }
    };

    const handleConvertToThree = async () => {
        formik.setFieldValue("st26input", "");
        const postData = {
            st26input: formik.values.st26input
            // Add other properties if needed
        };
        // Call the API and update the state with the response
        try {
            const response = await st26service.convertingSingleToThree(postData, history, t);
            if(response === 'empty'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The .txt file has no sequence data to be parsed.", toastRef);
                setConversionCompletedforSingle(false); 
            }else if(response === 'parsererror'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The data is not correctly structured.\nPlease correct the .txt and try again.", toastRef);
                setConversionCompletedforSingle(false);
            }else if(response === 'missing'){
                utilsService.showToast(TOAST_TYPE.ERROR, "The data is not correctly structured.\nEither the moltype or Sequence data is missing.", toastRef);
                setConversionCompletedforSingle(false);
            }else{
                setGetResponse(response);
                formik.setFieldValue("st26input", response); // Update the input field value
                setConversionCompletedforSingle(true); 
            }
        } catch (error) {
            console.error("Error during conversion:", error);
            // Handle the error if necessary
        }
    }

    function cncl() {
        history.push('/home');
    }

    const formik = useFormik({
        initialValues: {
            st26input: formdata.st26input

        },
        enableReinitialize: true,
        //validationSchema: Validate.AntibodySearchValidation(),
        onSubmit: async (values) => {
            let { st26input } = values;

            let postData = {
                st26input
            }
            let response;
            if(!toggle1){
                response = await st26service.convertingThreeToOne(postData, history, t);
            }
            else{
                response = await st26service.convertingSingleToThree(postData, history, t);
            }
            setGetResponse(response);

        },
    });
    return (
        <div className={classes.grow}>
            <form name="antibodySearchForm" onSubmit={formik.handleSubmit} className={classes.loginDiv}>
                {!toggle1 ?
                    <Row>
                        <Col lg="12" md="12" className={"mb-2 " + (authInfo && !authInfo.syscontrol_search_submit ? 'd-block' : 'd-none')}>
                            <Typography className="text-danger">
                                {t('ABsearchDisableText')}
                                {authInfo && authInfo.syscontrol_search_submit_txt}
                                {t('patienceThanksText')}</Typography>
                        </Col>
                        <Col>
                        {/* <Switch
                                checked={toggle1}
                                onChange={handleChanged}
                                sx={{
                                    '& .MuiSwitch-thumb': {
                                        border: '2px solid #1976d2', // Blue border around the thumb
                                    },
                                    '& .MuiSwitch-track': {
                                        border: '2px solid #1976d2', // Blue border around the track
                                        backgroundColor: toggle1 ? '#1976d2' : '#ccc', // Change color when toggled
                                    },
                                }}
                            /> */}
                        </Col>
                        <Col lg="12" md="12" className="mb-2">
                            <h6 className={"appTextColor loginTitle"}>Three Letter Code Conversion</h6>
                            <Row className="mb-3">
                                <Col lg="12" md="12" className="p-0 content float-left">
                                    <div className="form-group px-3 ">
                                        <TextInput
                                            spellcheck="false"
                                            rows="20"
                                            multiline={true}
                                            fullWidth
                                            id="letterCodeConversion"
                                            name="st26input"
                                            label="Copy and Paste your Three Letter sequences here"
                                            variant="outlined"
                                            value={formik.values.st26input}
                                            onChange={(event) => {
                                                formik.handleChange(event);
                                                if (!event.target.value) {
                                                    resetFileName(); // Clear file input when text input is cleared
                                                }
                                            }}                                            
                                            error={formik.touched.st26input && Boolean(formik.errors.st26input)}
                                            helperText={formik.errors.st26input}
                                        //disabled={authInfo && authInfo.redo}
                                        />
                                    </div>

                                </Col>

                            </Row>
                            <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                        </Col>

                        <Col lg="12" md="12" className="float-right mb-3">

                        <p className='uploadTextData'> <b id="show-text">Upload ST25, .txt file </b></p>
                        <input type="file" accept=".txt" onChange={showfil} />

                            {!formik.values.st26input ?
                                <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained">Convert to Single Letter Code</Button>
                                : <Button
                                className={classes.accountInfo}
                                color="default"
                                disableRipple={true}
                                variant="contained"
                                onClick={() => {
                                    if (conversionCompletedforThree) {
                                        downloadTextFile();
                                    } else {
                                        handleConvertToSingle();
                                    }
                                }}
                            >
                                {conversionCompletedforThree ? 'Download' : 'Convert to Single Letter Code'}
                            </Button>
                            }
                            {/* Convert to FASTA button - shown only after conversion is completed */}
                            {conversionCompletedforThree && (
                                <Button
                                    className={conversionCompletedforThree && userInfo.vmAccess === true ? classes.accountInfo : 'cancelButtonDisable'}
                                    color="default"
                                    disableRipple={true}
                                    variant="contained"
                                    style={{marginLeft: '10px'}}
                                    onClick={handleSequenceVariationSearch}
                                    disabled={!userInfo.vmAccess}
                                >
                                    Sequence Variation Search
                                </Button>
                            )}
                            {conversionCompletedforThree && (
                                <Button
                                    className={classes.accountInfo}
                                    color="default"
                                    disableRipple={true}
                                    variant="contained"
                                    style={{marginLeft: '10px'}}
                                    onClick={handleIpSequenceSearch}
                                >
                                    IP Sequence Search
                                </Button>
                            )}
                            <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} onClick={cncl}>{t('cancel')}</Button>

                            {/* <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} onClick={() => downloadTextFile()}>{'Download'}</Button> */}
                        </Col>
                    </Row>
                :
                <Row>
                    <Col lg="12" md="12" className={"mb-2 " + (authInfo && !authInfo.syscontrol_search_submit ? 'd-block' : 'd-none')}>
                        <Typography className="text-danger">
                            {t('ABsearchDisableText')}
                            {authInfo && authInfo.syscontrol_search_submit_txt}
                            {t('patienceThanksText')}</Typography>
                    </Col>
                    <Col>
                            <Switch
                                checked={toggle1}
                                onChange={handleChanged}
                            />
                        </Col>
                    <Col lg="12" md="12" className="mb-2">
                        <h6 className={"appTextColor loginTitle"}>Single Letter Code Conversion</h6>
                        <Row className="mb-3">

                            <Col lg="12" md="12" className="p-0 content float-left">
                                <div className="form-group px-3 ">
                                    <TextInput
                                        spellcheck="false"
                                        rows="20"
                                        multiline={true}
                                        fullWidth
                                        id="letterCodeConversion"
                                        name="st26input"
                                        label="Copy and Paste your Nucleotide sequences here"
                                        variant="outlined"
                                        value={formik.values.st26input}
                                        onChange={(event) => {
                                            formik.handleChange(event);
                                            if (!event.target.value) {
                                                resetFileName(); // Clear file input when text input is cleared
                                            }
                                        }}  
                                        error={formik.touched.st26input && Boolean(formik.errors.st26input)}
                                        helperText={formik.errors.st26input}
                                    //disabled={authInfo && authInfo.redo}
                                    />
                                </div>

                            </Col>

                        </Row>
                        <hr />
                    </Col>

                    <Col lg="12" md="12" className="float-right mb-3">

                        <p style={{display: 'table-cell' , fontSize: '15px' }}> <b id="show-text">Upload ST25, .txt File</b></p>
                        <input type="file" accept= ".txt" onChange={showfil} />
                        
                        {!formik.values.st26input ?
                            <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained" >Convert to Three Letter Code</Button>
                            : 
                            <Button
                                className={classes.accountInfo}
                                color="default"
                                disableRipple={true}
                                variant="contained"
                                onClick={() => {
                                    if (conversionCompletedforSingle) {
                                        downloadTextFile();
                                    } else {
                                        handleConvertToThree();
                                    }
                                }}
                            >
                                {conversionCompletedforSingle ? 'Download' : 'Convert to Three Letter Code'}
                            </Button> 
                        }
                        {!formik.values.st26input ?
                            <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained">Convert to Fasta</Button>
                            : <Button className={classes.accountInfo} color="default" disableRipple={true} variant="contained"  style={{marginRight: '10px'}}>Convert to Fasta</Button>
                        }
                        {/* {!formik.values.st26input ?
                            <Button className='cancelButtonDisable' color="default" disableRipple={true} variant="contained">Sequence Variation Search</Button>
                            : <Button className='accountInfo' color="default" disableRipple={true} variant="contained" style={{marginRight: '10px'}}>Sequence Variation Search</Button>
                        } */}
                        <Button variant="contained" disableRipple={true} color="default" className={classes.buttonStyleCancel} onClick={cncl}>{t('cancel')}</Button>

                    </Col>
                </Row>
                }  

            </form>
        </div>
    )
}

export default ThreeLetterCodeConversion;